import { render, staticRenderFns } from "./cerate-or-edit-baseinfo.vue?vue&type=template&id=69b55838&scoped=true"
import script from "./cerate-or-edit-baseinfo.vue?vue&type=script&lang=js"
export * from "./cerate-or-edit-baseinfo.vue?vue&type=script&lang=js"
import style0 from "./cerate-or-edit-baseinfo.vue?vue&type=style&index=0&id=69b55838&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b55838",
  null
  
)

export default component.exports